import { LogOut } from "lucide-react";
import { clearAuthCookies } from "@/lib/auth/cookies";
import { redirectToLogin } from "@/lib/auth/redirect";

/**
 * Admin top bar — minimal header with just the logout action for now.
 *
 * Future (when specific needs surface): user avatar + display name,
 * environment badge (BETA/PROD), version-update popup, maintenance
 * banner slot, tasks/notifications icons. Keep it empty until a module
 * port actually needs one of those.
 */
export function TopBar() {
  const handleLogout = () => {
    clearAuthCookies();
    redirectToLogin();
  };

  return (
    <header className="h-14 border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-950 px-6 flex items-center justify-end">
      <button
        type="button"
        onClick={handleLogout}
        className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white transition-colors"
      >
        <LogOut className="w-4 h-4" />
        <span>Log out</span>
      </button>
    </header>
  );
}
